import { userSelector } from '@lobby/store/selectors/user';
import { ofType } from 'redux-observable';
import { of, from } from 'rxjs';
import {
  switchMap, catchError, mergeMap, pluck,
} from 'rxjs/operators';

import { categories } from '../../categories';
import { notifications } from '../../notifications';
import { tables } from '../../tables';
import { user } from '../../user';
import { setFavorite } from './utils';

const tablesEpic = (action$, state$) => action$.pipe(
  ofType(tables.setFavorite),
  pluck('payload'),
  switchMap((params) => {
    const { identifier, favorite: favoriteTables } = userSelector(
      state$.value
    );

    return from(setFavorite({ ...params, identifier })).pipe(
      mergeMap(({ result }) => {
        const {
          table_changed,
          is_favorite: favorite,
          set_favorite: success,
        } = result;

        const tableId = +table_changed;

        if (!success) {
          return of(
            notifications.add({
              message: 'messages.failed_setting_favorite',
            })
          );
        }

        return of(
          // Update table favorite status
          tables.updateFavorite({
            tableId,
            favorite,
          }),
          // Update MyLobby category
          categories.updateFavorite({
            tableId,
            add: favorite,
          }),
          user.update({
            favorite: favorite
              ? [ ...favoriteTables, tableId ]
              : favoriteTables.filter((id) => id !== tableId),
          })
        );
      })
    );
  }),
  catchError(() => of(
    notifications.add({
      message: 'messages.failed_setting_favorite',
    })
  ))
);

export default tablesEpic;
